// extracted by mini-css-extract-plugin
export default {"card":"notFound_card__1dStW","txt":"notFound_txt__Qpvzv","boxImg":"notFound_boxImg__ygUu5","img":"notFound_img__2T9DG","bodyTxt":"notFound_bodyTxt__8iMq6"};